module.exports = __webpack_public_path__ + "img/image-thumb-3.75833a80.jpg";